import handler from 'api/handler'

const prefix = '/admin/partner'

const methods = {
  // Create new partner
  create: args => handler({ method: 'post', url: prefix + '/create', args, isFile: true }),
  
  // Update existing partner
  update: (id, args) => handler({ method: 'put', url: prefix + `/update/${id}`, args, isFile: true }),
  
  // Delete partner
  delete: id => handler({ method: 'delete', url: prefix + `/delete/${id}` }),
  
  // Fetch all partners
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  
  // Fetch single partner
  fetchById: id => handler({ method: 'get', url: prefix + `/fetch/${id}` }),
  
  // Toggle visibility
  toggleVisibility: args => handler({ method: 'patch', url: prefix + '/toggle-visibility', args }),
  
  // Update order
  updateOrder: args => handler({ method: 'patch', url: prefix + '/update-order', args })
}

export default methods

